<script>
import {cart} from "@/modules/cart";
import {mapStores} from "pinia";
import {useAuthStore} from "@/stores/auth";
import {api} from "@/modules/api";
import {toast} from "vue3-toastify";
import RatingNote from "@/components/reviews/RatingNote.vue";

export default {
  name: 'ProductBox',
  components: {RatingNote},
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      apiUrl: process.env.VUE_APP_API_URL
    }
  },
  computed: {
    api() {
      return api
    },
    ...mapStores(useAuthStore),
    isFavorite () {
      if (this.authStore.isConnected) {
        const user = this.authStore.getUser
        const favorite = this.product.Favorite.filter(fav => {
          return fav.userId === user.id
        })
        return favorite[0] ? favorite[0].isLike : false
      }
      return false
    },
    cart() {
      return cart
    },
    numberOfReviews () {
      return this.product.Reviews ? this.product.Reviews.length : 0
    },
    getNote () {
      let note = 0
      Object.values(this.product.Reviews).map(review => {
        note += review.note
      })
      if (note > 0) {
        return (note / this.product.Reviews.length).toFixed(1)
      }
      return 0
    }
  },
  methods: {
    addFavorites () {
      api.profil.updateFavorites(this.product.id).then((res) => {
        this.emitter.emit('load-data', true)
        toast(`Produit ${res.isLike ? 'ajouté à' : 'retiré de' } vos favoris !`)
      })
    }
  }
}
</script>

<template>
  <div class="rounded-lg mx-5 p-5 md:mx-0 border-gray-200 bg-white box">
    <div class="h-56 w-full">
      <router-link :to="{ name: 'app_view_product', params: { tag: product.tag } }">
        <img v-if="product.Images[0]" class="mx-auto h-full dark:hidden" :src="`${apiUrl}${product.Images[0].url}`" alt="" />
        <img v-else class="mx-auto h-full" src="https://flowbite.s3.amazonaws.com/blocks/e-commerce/imac-front-dark.svg" alt="" />
      </router-link>
    </div>
    <div class="pt-6">
      <div class="mb-4 flex items-center justify-between gap-4">
        <span class="me-2 rounded-full bg-primary-700/70 px-2.5 py-0.5 text-xs font-medium text-white">
          {{ product.category.Label }}
        </span>

        <div v-if="authStore.isConnected" class="flex items-center justify-end gap-1">
          <button @click="addFavorites" class="rounded-lg p-2 text-gray-500 hover:bg-gray-100 hover:text-gray-900">
            <i v-if="!isFavorite" class="fa-regular fa-heart"></i>
            <i v-else class="fa-solid fa-heart text-primary-950"></i>
          </button>
        </div>
      </div>

      <router-link :to="{ name: 'app_view_product', params: { tag: product.tag } }" class="text-lg font-semibold leading-tight text-gray-900 hover:underline dark:text-white">
        {{ product.title }}
      </router-link>
      <rating-note v-if="product.Reviews" :number-reviews="numberOfReviews" :note="getNote" />
      <div class="mt-4 flex items-center justify-between gap-4">
        <p class="text-2xl font-extrabold leading-tight text-gray-900 dark:text-white">
          {{ product.price }}€
        </p>

        <button v-if="authStore.isConnected" @click="cart.addProduct(product)" class="cart relative inline-flex items-center rounded-full bg-primary-700 p-5 text-sm font-medium text-white hover:bg-primary-800">
          <i class="fa-solid fa-plus absolute left-1/2 -translate-x-1/2 text-white"></i>
        </button>
        <button v-else @click="$router.push('/connexion')" class="cart relative inline-flex items-center rounded-full bg-primary-700 px-4 py-2 text-sm font-medium text-white hover:bg-primary-800">
          Se connecter
        </button>
      </div>
    </div>
  </div>
</template>

<style>
.cart {
  box-shadow: 4px 4px black;
  transition: box-shadow .3s ease-out;
}

.cart:hover {
  box-shadow: none;
  transition: box-shadow .3s ease-out;
}

.box:hover {
  border: 2px solid #c57f08;
  box-shadow: 4px 4px #c57f08;
  transition: box-shadow .3s ease-out;
}
</style>